import { sharedLib } from "@shared/services/shared.service";
import { OAuthPlatformType } from "@shared/types";

interface useSocialLoginsProps {
  openUrl: (url: string) => void;
}

const useSocialLogins = ({ openUrl }: useSocialLoginsProps) => {
  const [getLoginAuthUrl] =
    sharedLib.sharedApi.authentication.useLazyGetLoginAuthUrlQuery();

  const onLoginClick = async (oauthPlatformType: OAuthPlatformType) => {
    return getLoginAuthUrl({ oauth_platform: oauthPlatformType })
      .then((response) => {
        const url = response.data;
        url && openUrl(url);
      })
      .catch(() => {});
  };

  return {
    onLoginClick,
  };
};

export default useSocialLogins;
